import axios from '../api'
//基本信息
const baseInfo = () =>
	axios(
		'/yiqing/info', {
			p: 'w'
		}
	)
//疫情相关文案
const yqText = () =>
	axios(
		'/yiqing/text', {
			p: 'w'
		}
	)
//发送手机验证码
const sendSms = (device_uuid = '', phone = '', code = '') =>
	axios(
		'/send_sms', {
			p: 'w',
			device_uuid,
			phone,
			code
		}, 'POST'
	)
//验证图片验证码
const checkImgCode = (device_uuid = '', code = '') =>
	axios(
		'/cpt/check', {
			p: 'w',
			device_uuid,
			code
		}
	)
//验证码登录、自动注册
const autoRegister = (phone = '', smscode = '') =>
	axios(
		'/users/auto_token', {
			p: 'w',
			phone,
			smscode
		}, 'POST'
	)
//疫情问卷
const questionnaire = () =>
	axios(
		'/yiqing/wj', {
			p: 'w'
		}
	)
//查看问卷
const lookQuestionnaire = (torder_id = '', toi_id = '') =>
	axios(
		'/yiqing/wj_view', {
			p: 'w',
			torder_id,
			toi_id
		}
	)
//更新体温
const updateTemperature = (torder_id = '', toi_id = '', ck_temperature = '') =>
	axios(
		'/yiqing/wj_update', {
			p: 'w',
			torder_id,
			toi_id,
			ck_temperature
		}, 'POST'
	)
export default {
	baseInfo,
	yqText,
	sendSms,
	checkImgCode,
	autoRegister,
	questionnaire,
	lookQuestionnaire,
	updateTemperature
}


// WEBPACK FOOTER //
// ./src/http/modules/common.js